import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import { API_URL } from "../../utils/constant";

const RedTeamingResults = () => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchResults();
  }, []);

  const fetchResults = async () => {
    try {
      setLoading(true);
      const token = sessionStorage.getItem('token');
      
      const response = await fetch(`${API_URL}/red-teaming/reports`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch results');
      }

      const data = await response.json();
      setResults(Array.isArray(data) ? data : []);
    } catch (error) {
      // console.error removed
      toastr.error('Error', 'Failed to load results');
      
      // Fallback to mock data
      setResults([
        {
          id: 1,
          simulationName: "API Security Test",
          asset: "api.domain.com",
          attackType: "Directory Traversal",
          status: "success",
          duration: "5 minutes",
          findings: 1
        },
        {
          id: 2,
          simulationName: "Web Application Test",
          asset: "dev.site.io",
          attackType: "Command Injection",
          status: "blocked",
          duration: "3 minutes",
          findings: 0
        }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'success': return 'success';
      case 'blocked': return 'warning';
      case 'error': return 'danger';
      default: return 'secondary';
    }
  };

  if (loading) {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body text-center">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="page-title-box">
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/red-teaming">Red Teaming</Link>
                </li>
                <li className="breadcrumb-item active">Results</li>
              </ol>
            </div>
            <h4 className="page-title">Red Teaming Results</h4>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <h4 className="header-title mb-3">Simulation Results</h4>
              
              <div className="table-responsive">
                <table className="table table-centered table-hover mb-0">
                  <thead>
                    <tr>
                      <th>Simulation</th>
                      <th>Asset</th>
                      <th>Attack Type</th>
                      <th>Status</th>
                      <th>Duration</th>
                      <th>Findings</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(Array.isArray(results) ? results : []).map((result) => (
                      <tr key={result.id}>
                        <td>{result.simulationName}</td>
                        <td>{result.asset}</td>
                        <td>{result.attackType}</td>
                        <td>
                          <span className={`badge badge-${getStatusColor(result.status)}`}>
                            {result.status}
                          </span>
                        </td>
                        <td>{result.duration}</td>
                        <td>
                          {result.findings > 0 && (
                            <span className="badge badge-info">
                              {result.findings} finding{result.findings !== 1 ? 's' : ''}
                            </span>
                          )}
                        </td>
                        <td>
                          <button className="btn btn-sm btn-info">
                            <i className="fa fa-eye"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RedTeamingResults; 